import React from 'react';
import {useSelector} from "react-redux";
import styles from "./fullpage-loader.module.scss";

function FullPageLoader() {
  const loader = useSelector((state: any) => state.loader.state);

  return loader ? (
      <div className={styles.fullPageLoader}>
          <div className={styles.loading}>
              <div className={styles.loadingText}>
                  {"TEXTNEVIS".split('').map((ch, i) => (<span key={'txt' + i} className={styles.char}>{ch}</span>))}
              </div>
          </div>
      </div>
  ) : <></>;
}

export default FullPageLoader;
